import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function MoveMail({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.EMAIL.MOVE-MAIL.';
    return (
        <>
            <div className="form-element">
                {t(label + 'DESTINATION')}
                <TextInput action={action} inputName="destinationFolder" variables={variables} setOpenVariable={setOpenVariable} isRequired />
            </div>
            <div className="form-element">
                {t(label + 'ID')}
                <TextInput action={action} inputName="id" variables={variables} setOpenVariable={setOpenVariable} isRequired />
            </div>
        </>
    );
}
export default MoveMail;